import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from "react-select";
import { Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SubSpecialCase = ({ show, onClose, data, id, refresh }) => {
    
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [alldays, setalldays] = useState(null);
    const [sunday, setsunday] = useState('');
    const [monday, setmonday] = useState('');
    const [tuesday, settuesday] = useState('');
    const [wednesday, setwednesday] = useState('');
    const [thursday, setthursday] = useState('');
    const [friday, setfriday] = useState('');
    const [saturday, setsaturday] = useState('');

    const [prodrel, setProdRel] = useState({});
    const [itemCategoryIds, setItemCategoryIds] = useState([]);
    const [itemsoption, setitemoptions] = useState([]);
    const [selectedItem, setSelecteditem] = useState(null);
    const [replaceitemopt, setReplace] = useState([]);
    const [replaceditem, setReplacedItem] = useState(null);

    useEffect(() => {
        if (data) {
            setalldays(data.timelinerelation.all_days);
            setsunday(data.timelinerelation.sunday);
            setmonday(data.timelinerelation.monday);
            settuesday(data.timelinerelation.tuesday);
            setwednesday(data.timelinerelation.wednesday);
            setthursday(data.timelinerelation.thursday);
            setfriday(data.timelinerelation.friday);
            setsaturday(data.timelinerelation.saturday);
            setProdRel(data.productrelation);
        }
        if (data?.productrelation?.item_category_list) {
            try {
                // Parse the JSON string into an array
                const parsedList = JSON.parse(data.productrelation.item_category_list);

                // Extract item_category_id values
                const ids = parsedList.map(item => item.item_category_id);

                // Set in state
                setItemCategoryIds(ids);
            } catch (error) {
                console.log('Failed to parse item_category_list:', error);
            }
        }
    }, [data]);

    useEffect(() => {
        console.log(itemCategoryIds);
        if (itemCategoryIds.length>0) {
            const postData = {category_ids: itemCategoryIds}
            axios.post(`${baseURL}/dropdown/items_by_categories`, postData)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.name,
                }));
                setitemoptions(formatted);
                setReplace(formatted);
            }).catch(error => {
                console.log(error);
            });
        }
    }, [itemCategoryIds]);

    const handleSelectChange = (selected) => {
        setSelecteditem(selected);

        // Remove selected item from replaceitemopt
        setReplace(itemsoption.filter(item => item.value !== selected.value));
    };

    const [item, setItem] = useState('');
    const [reason, setreason] = useState('');

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        
        if (!selectedItem) {
            newErrors.sitem = "This Field is Required.";
        }

        if (!replaceditem) {
            newErrors.ritem = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const postData = {
            item: selectedItem.value,       // e.g., 1
            replaceitem: replaceditem.value, // e.g., 5
            special_case: {
                item: selectedItem.label,       // item name string
                replace: replaceditem.label,    // replace item name string
                reason: reason || ''            // your reason string
            }
        };
        console.log(postData);

        axios.put(`${baseURL}/subscription/special_case/${id}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Subscription Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscription Updation Failed");
            });
    };

    

    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Special Case</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                                <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                <label className='text-black fs-6 font-w500'>{data.lead_mobile_no}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Product</label>
                                <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                                <label className='text-black fs-6 font-w500'>{data.timeline_name} ({data.timeline_days} Days)</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Days</label>
                                <label className='text-black fs-6 font-w500'>
                                    {alldays === 0
                                        ? 'All'
                                        : [
                                            monday === "0" && 'Mon',
                                            tuesday === "0" && 'Tue',
                                            wednesday === "0" && 'Wed',
                                            thursday === "0" && 'Thu',
                                            friday === "0" && 'Fri',
                                            saturday === "0" && 'Sat',
                                            sunday === "0" && 'Sun',
                                        ]
                                        .filter(Boolean)
                                        .join(', ')
                                    }
                                </label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Area</label>
                                <label className='text-black fs-6 font-w500'>{data.area_name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Delivery Point</label>
                                <label className='text-black fs-6 font-w500'>{data.deliverypoint_name}</label>
                            </div>
                            <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Address</label>
                                <label className='text-black fs-6 font-w500'>{data.address ? data.address : '-'}</label>
                            </div>
                            {/* <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Item Swaps<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Item Swaps" 
                                    maxLength={200}
                                    value={item}
                                    onChange={(e) => setItem(e.target.value)}
                                />
                                {errors.item && <div className="text-danger fs-8 mt-1">{errors.item}</div>}
                            </div> */}


                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Selected Item<span className="required">*</span></label>
                                <Select
                                    placeholder="Select Item"
                                    onChange={handleSelectChange}
                                    options={itemsoption}
                                />
                                {errors.sitem && <div className="text-danger fs-8 mt-1">{errors.sitem}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Replacement Item<span className="required">*</span></label>
                                <Select
                                    placeholder="Select Item"
                                    options={replaceitemopt}
                                    onChange={(selected) => {
                                        setReplacedItem(selected);
                                    }}
                                />
                                {errors.ritem && <div className="text-danger fs-8 mt-1">{errors.ritem}</div>}
                            </div>


                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Reason</label>
                                <input type="text" className="form-control" placeholder="Enter Reason" 
                                    maxLength={200}
                                    value={reason}
                                    onChange={(e) => setreason(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            {/* <Link className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button className="btn btn-sm btn-primary">Special Case<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default SubSpecialCase;
